import styled, { css } from 'styled-components';
import { color, space, typography } from 'styled-system';
import { rgba } from 'utils/polished';

import LayoutStyles from './layoutStyles';
import ButtonStyles from '../base/buttonStyles';
import PanelStyles from '../base/panelStyles';

const ModalNavigationStyles = styled.div`
  position: fixed;
  right: ${props => props.theme.space[3]};
  z-index: 10;
  text-align: right;

  ${PanelStyles} {
    text-align: initial;
  }
`;

const ModalHeaderStyles = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${ButtonStyles} {
    @media screen and (max-width: 1023px) {
      margin-right: 0;
    }
  }
`;

const ModalHeadingStyles = styled.h1`
  padding: 0 ${props => props.theme.space[2]};
  color: ${props => props.theme.colors.white};
  font-weight: bold;
  font-size: 1rem;
`;

const ModalBodyStyles = styled.div`
  flex-shrink: 1;
  overflow: auto;
  overflow-x: hidden;
`;
const ModalFooterStyles = styled.div`
  ${space}

  display: flex;
  justify-content: space-between;

  ${props =>
    props.mt === undefined &&
    css`
      margin-top: 1rem;
    `};

  @media screen and (max-width: 1023px) {
    margin-top: ${props => props.theme.space[3]};
    flex-direction: column-reverse;

    ${ButtonStyles} {
      margin: 0 0 ${props => props.theme.space[1]} 0;
      width: 100%;
    }
  }
`;

// For the sake of compatibility with Blueprint library the maximal z-index is 19.
const ModalOverlayStyles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 19;
  display: none;
  background: ${props => rgba(props.theme.colors.white, 0.8)};
  align-items: ${props => props.position};
  justify-content: center;
  overflow: auto;

  ${props =>
    props.visible &&
    css`
      display: flex;
    `};
`;

const ModalStyles = styled.div`
  ${typography}
  ${color}

  box-shadow: ${props => props.theme.boxShadow};
  border: 0.0625rem solid ${props => props.theme.colors.separator};
  margin: ${props => props.theme.space[3]};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  ${props =>
    props.$size === 'small' &&
    css`
      max-width: 300px;
    `};

  ${props =>
    props.$size === 'middle' &&
    css`
      max-width: 640px;
    `};

  ${props =>
    props.$size === 'large' &&
    css`
      max-width: 1310px;
    `};

  ${props =>
    typeof props.$size === 'number' &&
    css`
      max-width: ${props.$size}px;
    `};

  ${props =>
    props.$size === 'fullScreen' &&
    css`
      border: 0;
      position: fixed;
      padding: 1rem 0 0 0;
      height: 100%;
      max-width: unset;
      display: flex;
      flex-direction: column;

      ${ModalOverlayStyles} {
        padding: 0;
      }

      ${LayoutStyles.ContainerStyles} {
        max-width: initial;
        display: flex;
        justify-content: space-between;
        width: 100%;
      }

      ${LayoutStyles.MainStyles} {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: space-between;
        padding-left: ${props.theme.space[3]};
        padding-right: ${props.theme.space[3]};
      }
    `};
`;

const ModalPagingStyles = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ffffff55;
  border-radius: 10px;

  margin-left: ${props => props.theme.space[3]};

  padding-left: ${props => props.theme.space[1]};
  padding-right: ${props => props.theme.space[1]};
`;

ModalStyles.OverlayStyles = ModalOverlayStyles;
ModalStyles.NavigationStyles = ModalNavigationStyles;
ModalStyles.HeaderStyles = ModalHeaderStyles;
ModalStyles.HeadingStyles = ModalHeadingStyles;
ModalStyles.BodyStyles = ModalBodyStyles;
ModalStyles.FooterStyles = ModalFooterStyles;
ModalStyles.PagingStyles = ModalPagingStyles;

export default ModalStyles;
